var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t("welcome"))+" "+_vm._s(_vm.$store.state.name))]),_c('v-card-text',[_vm._v("\n            The requested page does not exist\n        ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }